export default __webpack_public_path__ + "static/media/noInfo.3c00c6c7.svg";